import { useCallback, useContext, useEffect, useRef } from "react";
import { Tooltip } from "primereact/tooltip";
import { useLocation } from "react-router-dom";
import AppMenuitem from "./AppMenuitem";
import { LayoutContext } from "./context/layoutcontext";
import { MenuProvider } from "./context/menucontext";
import type { MenuProps } from "../types/layout";

const AppSubMenu = (props: MenuProps) => {
  const { layoutState, setBreadcrumbs } = useContext(LayoutContext);
  const tooltipRef = useRef<Tooltip | null>(null);
  const { pathname } = useLocation();

  const hideTooltip = () => {
    if (tooltipRef.current) {
      tooltipRef.current.hide();
      (tooltipRef.current as any).updateTargetEvents();
    }
  };

  useEffect(() => {
    hideTooltip();
  }, [layoutState.overlaySubmenuActive, pathname]);

  const generateBreadcrumbs = useCallback(
    (model) => {
      const breadcrumbs = [];

      const getBreadcrumb = (item, labels = []) => {
        const { label, to, items } = item;

        label && labels.push(label);
        items &&
          items.forEach((_item) => {
            getBreadcrumb(_item, labels.slice());
          });
        to && breadcrumbs.push({ labels, to });
      };

      model.forEach((item) => {
        getBreadcrumb(item);
      });
      setBreadcrumbs(breadcrumbs);
    },
    [setBreadcrumbs]
  );

  // Regenerates when the menu itself changes — a role can add or remove an
  // entry. AppMenu memoises the model so this is not per-render.
  useEffect(() => {
    generateBreadcrumbs(props.model);
  }, [generateBreadcrumbs, props.model]);

  return (
    <MenuProvider>
      <ul className="layout-menu">
        {props.model.map((item, i) => {
          return !item.separator ? (
            <AppMenuitem item={item} root={true} index={i} key={item.label} />
          ) : (
            <li key={i} className="menu-separator"></li>
          );
        })}
      </ul>
      <Tooltip
        ref={tooltipRef}
        target="li:not(.active-menuitem)>.tooltip-target"
      />
    </MenuProvider>
  );
};

export default AppSubMenu;
